import React from "react";
import '../../assets/css/bootstrap.min.css';
import '../../assets/css/animate.min.css';
import '../../assets/css/fontawesome.min.css';
import '../../assets/css/line-awesome.min.css';
import '../../assets/css/keyframe-animation.css';
import '../../assets/css/jquery.datetimepicker.min.css';
import '../../assets/css/nice-select.css';
import '../../assets/css/venobox.min.css';
import '../../assets/css/swiper.min.css';
import '../../assets/css/elements.css';
import '../../assets/css/header.css';
import '../../assets/css/slider.css';
import '../../assets/css/blog.css';
import '../../assets/css/main.css';
import '../../assets/css/responsive.css';
import { Link } from "react-router-dom";


function Home() {
  return (
    <div>
      <header className="main-header">
        <div className="top-header">
          <div className="container">
            {/* <div className="top-header-wrap">
              <div className="top-left">
                <p>Reliable Taxi Service & Transport Solutions!</p>
              </div>
              <div className="top-right">
                <ul className="top-header-nav">
                  <li>
                    <a href="faqs.html">Help</a>
                  </li>
                  <li>
                    <a href="contact.html">Support</a>
                  </li>
                  <li>
                    <a href="faqs.html">FAQ</a>
                  </li>
                </ul>
                <ul className="header-social-share">
                  <li>
                    <a href="#">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>
        <div className="mid-header">
          <div className="container">
            <div className="mid-header-wrap">
              <div className="site-logo">
                <a href="index.html">
                  <img src="/assets/img/logo4.png" alt="Logo" width="80px"/>
                </a>
                <p style={{color:"#04542E",fontWeight:"bold",marginBottom:"0px",fontSize:"20px"}}>GoSafari</p>
              </div>
              <ul className="header-info">
                <li>
                  <div className="header-info-icon">
                    <i className="las la-phone-volume"></i>
                  </div>
                  <div className="header-info-text">
                    <h3>
                      <span>Call us now</span>
                      <a href="tel:+9779852020093">+977-9852020093</a>
                    </h3>
                  </div>
                </li>
                <li>
                  <div className="header-info-icon">
                    <i className="las la-envelope-open"></i>
                  </div>
                  <div className="header-info-text">
                    <h3>
                      <span>Email now</span>info@gosafarinepal.com
                    </h3>
                  </div>
                </li>
                <li>
                  <div className="header-info-icon">
                    <i className="las la-map-marked-alt"></i>
                  </div>
                  <div className="header-info-text">
                    <h3>
                      <span>Halk Street</span>Biratnagar, Nepal
                    </h3>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="nav-menu-wrapper">
          <div className="container">
            <div className="nav-menu-inner">
              <div className="site-logo">
                <a href="index.html">
                  <img src="/assets/img/logo-dark.png" alt="Logo" />
                </a>
              </div>
              <div className="header-menu-wrap">
                <ul className="nav-menu">
                  <li className="active dropdown_menu">
                    <a href="index.html">Home</a>
                    {/* <ul>
                      <li>
                        <a href="index.html">Home Default</a>
                      </li>
                      <li>
                        <a href="index-2.html">Home Modern</a>
                      </li>
                    </ul> */}
                  </li>
                  {/* <li className="dropdown_menu">
                    <a href="about-us.html">Company</a>
                    <ul>
                      <li>
                        <a href="about-us.html">About Us</a>
                      </li>
                      <li>
                        <a href="about-company.html">About Company</a>
                      </li>
                      <li>
                        <a href="our-services.html">Our Services</a>
                      </li>
                      <li>
                        <a href="service-details.html">Services Details</a>
                      </li>
                      <li>
                        <a href="book-taxi.html">Book a Ride</a>
                      </li>
                    </ul>
                  </li> */}
                </ul>
              </div>
              <div className="menu-right-item">
                <div className="search-icon dl-search-icon">
                  <i className="las la-search"></i>
                </div>
                <div className="sidebox-icon dl-sidebox-icon">
                  <i className="las la-bars"></i>
                </div>
                <a href="book-taxi.html" className="menu-btn">
                  Book a Taxi
                </a>
              </div>
              <div className="mobile-menu-icon">
                <div className="burger-menu">
                  <div className="line-menu line-half first-line"></div>
                  <div className="line-menu"></div>
                  <div className="line-menu line-half last-line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div id="searchbox-overlay"></div>
      <div id="popup-search-box">
        <div className="box-inner-wrap d-flex align-items-center">
          <form id="form" action="#" method="get" role="search">
            <input
              id="popup-search"
              type="text"
              name="s"
              placeholder="Type keywords here..."
            />
            <button id="popup-search-button" type="submit" name="submit">
              <i className="las la-search"></i>
            </button>
          </form>
          <div className="search-close">
            <i className="las la-times"></i>
          </div>
        </div>
      </div>
      <div id="popup-sidebox" className="popup-sidebox">
      <div className="sidebox-content">
        <div className="site-logo">
          <a href="index.html">
            <img src="/assets/img/logo-light.png" alt="logo" />
          </a>
        </div>
        <p>
          Everything your taxi business needs is already here! Ridek, a theme
          made for taxi service companies.
        </p>
        <ul className="sidebox-list">
          <li className="call">
            <span>Call for ride:</span> 5267-214-392
          </li>
          <li>
            <span>You can find us at:</span> Halk Street New York, USA - 2386
          </li>
          <li>
            <span>Email now:</span> Info.ridek@mail.com
          </li>
        </ul>
      </div>
    </div>
    <div id="sidebox-overlay"></div>
    <div className="slider-section">
      <div className="main-slider">
        <div className="swiper-wrapper">
          {[...Array(2)].map((_, index) => (
            <div className="swiper-slide" key={index}>
              <div className="slider-img">
                <img
                  src="/assets/img/slider-bg.jpg"
                  alt="img"
                  className="kenburns"
                  style={{ animationDuration: '12000ms' }}
                />
              </div>
              <div className="car-holder">
                <img
                  src="/assets/img/car-1.png"
                  alt="car"
                  data-animation="car-animation"
                  data-duration="1.5s"
                />
                <div className="shape">
                  <div
                    data-animation="slide-in-bottom"
                    data-duration="1.5s"
                    data-delay="0.3s"
                  ></div>
                  <div
                    data-animation="fade-in"
                    data-duration="1.5s"
                    data-delay="0.2s"
                  ></div>
                  <div
                    data-animation="slide-in-top"
                    data-duration="1.5s"
                    data-delay="0.5s"
                  ></div>
                </div>
              </div>
              <div className="slider-content-wrap d-flex align-items-center text-left">
                <div className="container">
                  <div className="slider-content">
                    <div className="slider-caption medium">
                      <div className="inner-layer">
                        <div data-animation="fade-in-bottom" data-delay="0.3s">
                          Travel securely with us!
                        </div>
                      </div>
                    </div>
                    <div className="slider-caption big">
                      <div className="inner-layer">
                        <div data-animation="fade-in-bottom" data-delay="0.5s">
                          Book your taxi from <br /> anywhere today!
                        </div>
                      </div>
                    </div>
                    <div className="slider-caption small">
                      <div className="inner-layer">
                        <div
                          data-animation="fade-in-bottom"
                          data-delay="0.7s"
                          data-duration="1s"
                        >
                          Everything your taxi business needs is already here! <br /> Ridek made for taxi
                          service companies!
                        </div>
                      </div>
                    </div>
                    <div className="slider-btn">
                      <a
                        href="book-taxi.html"
                        className="default-btn"
                        data-animation="fade-in-bottom"
                        data-delay="0.9s"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Slider navigation buttons */}
        <div className="slider-controls">
          <div className="slider-control slider-button-prev">
            <span>
              <i className="las la-long-arrow-alt-left"></i>
            </span>
            Prev
          </div>
          <div className="slider-pagination"></div>
          <div className="slider-control slider-button-next">
            Next
            <span>
              <i className="las la-long-arrow-alt-right"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <section className="about-section padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="about-img">
              <img
                className="about-img1 wow fade-in-left"
                data-wow-delay="200ms"
                src="/assets/img/about-1.png"
                alt="img"
              />
              <img
                className="about-img2 wow fade-in-bottom"
                data-wow-delay="400ms"
                src="/assets/img/about-2.png"
                alt="img"
              />
              <figure className="round-text">
                <img src="/assets/img/experience-text-round.png" alt="img" />
              </figure>
            </div>
          </div>
          <div className="col-md-6">
            <div className="section-heading mb-40 wow fade-in-right" data-wow-delay="200ms">
              <h4>
                <span></span>About Our Company
              </h4>
              <h2>Feel the difference and Relaxation with Ridek Taxi Company!</h2>
              <p>
                We successfully cope with tasks of varying complexity, provide long-term guarantees and
                regularly master new technologies. Our portfolio includes dozens of successfully completed
                projects of houses of different storeys, with high-quality finishes and good repairs. Book
                your taxi from anywhere today!
              </p>
            </div>
            <ul className="about-info wow fade-in-right" data-wow-delay="400ms">
              <li>
                <img
                  className="owner-thumb"
                  src="/assets/img/comment-1.png"
                  alt="thumb"
                />
                <div className="owner">
                  <h4>Founder</h4>
                  {/* <img className="signature" src="/assets/img/signature.png" alt="signature" /> */}
                  <h2 style={{marginTop:"5px",color:"#04542E"}}>Mr. Rajesh Bhattarai</h2>
                </div>
              </li>
              <li>
                <h2>
                  <span>Call For Taxi</span>
                  <a href="tel:+9779852020093">+977-9852020093</a>
                </h2>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section className="service-section bg-grey padding">
      <div className="bg-half"></div>
      <div className="container">
        <div className="section-heading text-center mb-40 wow fade-in-bottom" data-wow-delay="200ms">
          <h4><span></span>What We Offer</h4>
          <h2 className="white">
            Start your journey with<br /> Ridek Taxi Company!
          </h2>
          <p>
            We successfully cope with tasks of varying complexity, provide long-term <br /> guarantees and
            regularly master new technologies.
          </p>
        </div>

        <div className="swiper-outside">
          <div className="service-carousel">
            <div className="swiper-wrapper">
              {[...Array(5)].map((_, index) => (
                <div className="swiper-slide" key={index}>
                  <div className="service-item wow fade-in-bottom" data-wow-delay={`${(index + 1) * 200}ms`}>
                    <div className="service-thumb">
                      <img
                        src={`assets/img/service-${index + 1}.jpg`}
                        alt="img"
                      />
                      <div className="service-shape-wrap">
                        <div className="service-shape"></div>
                      </div>
                      <div className="service-car">
                        <img src="/assets/img/car-1.png" alt="car" />
                      </div>
                    </div>
                    <div className="service-content">
                      <h3>
                        <a href="service-details.html">{`Service ${index + 1}`}</a>
                      </h3>
                      <p>
                        Everything your taxi business needs is already here! Ridek made for taxi service
                        companies!
                      </p>
                      <a className="read-more" href="service-details.html">Read More</a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="swiper-pagination"></div>
          </div>

          {/* Carousel Arrows */}
          <div className="swiper-nav swiper-next">
            <i className="las la-long-arrow-alt-right"></i>
          </div>
          <div className="swiper-nav swiper-prev">
            <i className="las la-long-arrow-alt-left"></i>
          </div>
        </div>
      </div>
    </section>
    <section className="booking-section">
      <div className="container">
        <div className="row pos-relative padding">
          <div className="col-lg-4">
            <div className="booking-car wow fade-in-left" data-wow-delay="200ms"></div>
          </div>
          <div className="col-lg-8">
            <div className="booking-wrap">
              <div className="section-heading mb-30">
                <h4><span></span>Online Booking</h4>
                <h2 className="white">Book Your Taxi Ride</h2>
              </div>
              <form action="https://html.dynamiclayers.net/dl/ridek/book-ride.php" id="book-taxi-ride">
                <div className="booking-form">
                  <div className="form-field">
                    <i className="las la-user-tie"></i>
                    <input
                      type="text"
                      id="full-name"
                      name="full-name"
                      className="form-control"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="form-field">
                    <i className="las la-envelope-open"></i>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      required
                    />
                  </div>
                  <div className="form-field">
                    <i className="las la-tags"></i>
                    <select name="package-type" id="type" className="niceSelect">
                      <option value="standard">Standard</option>
                      <option value="business">Business</option>
                      <option value="economy">Economy</option>
                      <option value="vip-spacial">VIP Spacial</option>
                      <option value="comfort">Comfort</option>
                    </select>
                  </div>
                  <div className="form-field">
                    <i className="las la-user-friends"></i>
                    <select name="passengers" id="passengers" className="niceSelect">
                      <option value="1">1 Person</option>
                      <option value="2">2 Person</option>
                      <option value="3">3 Person</option>
                      <option value="4">4 Person</option>
                      <option value="5">5 Person</option>
                    </select>
                  </div>
                  <div className="form-field">
                    <i className="las la-map-marker"></i>
                    <input
                      type="text"
                      id="start-dest"
                      name="start-dest"
                      className="form-control"
                      placeholder="Start Destination"
                      required
                    />
                  </div>
                  <div className="form-field">
                    <i className="las la-map-marker"></i>
                    <input
                      type="text"
                      id="end-dest"
                      name="end-dest"
                      className="form-control"
                      placeholder="End Destination"
                      required
                    />
                  </div>
                  <div className="form-field">
                    <i className="las la-calendar"></i>
                    <input
                      type="text"
                      id="ride-date"
                      name="ride-date"
                      className="form-control date-picker"
                      placeholder="Select Date"
                      required
                    />
                  </div>
                  <div className="form-field">
                    <i className="las la-clock"></i>
                    <input
                      type="text"
                      id="ride-time"
                      name="ride-time"
                      className="form-control time-picker"
                      placeholder="Select Time"
                      required
                    />
                  </div>
                  <div className="form-field">
                    <button id="submit" className="default-btn" type="submit">Book Your Taxi</button>
                  </div>
                </div>
                <div id="form-messages" className="alert" role="alert"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="pricing-section bg-grey bd-bottom padding">
      <div className="container">
        <div className="section-heading text-center mb-40 wow fade-in-bottom" data-wow-delay="200ms">
          <h4><span></span>Lets Go With Us!</h4>
          <h2>Choose Your Taxi to Ride!</h2>
          <p>We successfully cope with tasks of varying complexity, provide long-term <br />guarantees and regularly master new technologies.</p>
        </div>
        {/* Tab Menu */}
        <ul className="nav pricing-tab-menu" id="pricing-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button className="nav-link active" id="hybrid-taxi" data-bs-toggle="tab" data-bs-target="#hybrid-taxi-content" type="button" role="tab" aria-controls="hybrid-taxi-content" aria-selected="true">
              Hybrid Taxi
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="town-taxt" data-bs-toggle="tab" data-bs-target="#town-taxi-content" type="button" role="tab" aria-controls="town-taxi-content" aria-selected="false">
              Town Taxi
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="limousine-taxi" data-bs-toggle="tab" data-bs-target="#limousine-taxi-content" type="button" role="tab" aria-controls="limousine-taxi-content" aria-selected="false">
              Limousine Taxi
            </button>
          </li>
        </ul>

        {/* Tab Content */}
        <div className="tab-content" id="pricing-tab-content">
          {/* Hybrid Taxi Content */}
          <div className="tab-pane fade show active" id="hybrid-taxi-content" role="tabpanel" aria-labelledby="hybrid-taxi">
            <div className="row">
              {[1, 2, 3].map((item) => (
                <div key={item} className="col-lg-4 col-md-6 sm-padding">
                  <div className="pricing-item">
                    <div className="pricing-head-wrap">
                      <div className="pricing-car">
                        <img src="/assets/img/pricing-car.png" alt="car" />
                        <div className="price">$2.50/km</div>
                      </div>
                    </div>
                    <div className="pricing-head">
                      <h3><a href="taxi-details.html">BMW X5 2008</a></h3>
                      <span className="location">Chicago</span>
                    </div>
                    <ul className="pricing-list">
                      <li>Initial Charge: <span>$2.50</span></li>
                      <li>Per Mile/KM: <span>$4.20</span></li>
                      <li>Per Stopped Trafic: <span>$1.50</span></li>
                      <li>Passengers: <span>4 Person</span></li>
                      <li><a href="book-taxi.html" className="default-btn">Book Taxi Now</a></li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Town Taxi Content */}
          <div className="tab-pane fade" id="town-taxi-content" role="tabpanel" aria-labelledby="town-taxi">
            <div className="row">
              {[1, 2, 3].map((item) => (
                <div key={item} className="col-lg-4 col-md-6 sm-padding">
                  <div className="pricing-item">
                    <div className="pricing-head-wrap">
                      <div className="pricing-car">
                        <img src="/assets/img/pricing-car.png" alt="car" />
                        <div className="price">$3.50/km</div>
                      </div>
                    </div>
                    <div className="pricing-head">
                      <h3><a href="taxi-details.html">Mercedes-Benz</a></h3>
                      <span className="location">Florida</span>
                    </div>
                    <ul className="pricing-list">
                      <li>Initial Charge: <span>$2.50</span></li>
                      <li>Per Mile/KM: <span>$4.20</span></li>
                      <li>Per Stopped Trafic: <span>$1.50</span></li>
                      <li>Passengers: <span>4 Person</span></li>
                      <li><a href="book-taxi.html" className="default-btn">Book Taxi Now</a></li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Limousine Taxi Content */}
          <div className="tab-pane fade" id="limousine-taxi-content" role="tabpanel" aria-labelledby="limousine-taxi">
            <div className="row">
              {[1, 2, 3].map((item) => (
                <div key={item} className="col-lg-4 col-md-6 sm-padding">
                  <div className="pricing-item">
                    <div className="pricing-head-wrap">
                      <div className="pricing-car">
                        <img src="/assets/img/pricing-car.png" alt="car" />
                        <div className="price">$4.50/km</div>
                      </div>
                    </div>
                    <div className="pricing-head">
                      <h3><a href="taxi-details.html">Hyundai 2022</a></h3>
                      <span className="location">New York</span>
                    </div>
                    <ul className="pricing-list">
                      <li>Initial Charge: <span>$2.50</span></li>
                      <li>Per Mile/KM: <span>$4.20</span></li>
                      <li>Per Stopped Trafic: <span>$1.50</span></li>
                      <li>Passengers: <span>4 Person</span></li>
                      <li><a href="book-taxi.html" className="default-btn">Book Taxi Now</a></li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="download-section bd-bottom padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-heading wow fade-in-left" data-wow-delay="200ms">
              <h4><span></span>Online Booking</h4>
              <h2>Get the Ridek Mobile app and Start Your Journey!</h2>
              <p>
                We successfully cope with tasks of varying complexity, provide long-term guarantees and
                regularly master technologies.
              </p>
              <ul className="app-feature">
                <li>
                  <i><img className="feature-icon" src="/assets/img/icon-navigator.svg" alt="icon" /></i>
                  <h3>Easy to Search <br /> Ridek Taxi!</h3>
                </li>
                <li>
                  <i><img className="feature-icon" src="/assets/img/icon-clock.svg" alt="icon" /></i>
                  <h3>Quick Pickups To <br /> Save Time!</h3>
                </li>
                <li>
                  <i><img className="feature-icon" src="/assets/img/icon-docs.svg" alt="icon" /></i>
                  <h3>Inclusive Rates To<br /> Enjoy Ride!</h3>
                </li>
              </ul>
              <div className="download-btn">
                <a href="https://play.google.com/store/apps/details?id=com.company.gosafari">
                  <img src="/assets/img/google-play.svg" alt="PlayStore" />
                </a>
                {/* <a href="#">
                  <img src="/assets/img/app-store.svg" alt="AppStore" />
                </a> */}
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-none d-lg-block">
            <div className="taxi-holder">
              <div className="taxi wow fade-in-left" data-wow-delay="300ms"></div>
              <div className="mockup wow fade-in-bottom" data-wow-delay="400ms"></div>
              <div className="charecter wow fade-in-right" data-wow-delay="500ms"></div>
              <img className="location-marker" src="/assets/img/location-marker.png" alt="location" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="testimonial-section bg-grey">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="section-heading mb-10">
              <h4><span></span>Clients Testimonial</h4>
              <h2>Ridek Passenger Reviews...</h2>
              <p>
                We successfully cope with tasks of varying complexity, provide long-term guarantees and
                regularly master technologies.
              </p>
            </div>
            <div className="swiper-outside testi-pagination">
              <div className="testimonial-carousel">
                <div className="swiper-wrapper">
                  {[
                    {
                      quote: 'Good to have transportation available in places and times it is otherwise hard to find, but the app has always been a bit difficult to use especially how it works or doesnt with large font phone settings.',
                      author: 'Eredrik Johanson',
                      company: 'Financial .INC',
                      image: 'assets/img/comment-1.png'
                    },
                    {
                      quote: 'Good to have transportation available in places and times it is otherwise hard to find, but the app has always been a bit difficult to use especially how it works or doesnt with large font phone settings.',
                      author: 'Eredrik Johanson',
                      company: 'Financial .INC',
                      image: 'assets/img/comment-1.png'
                    },
                    {
                      quote: 'Good to have transportation available in places and times it is otherwise hard to find, but the app has always been a bit difficult to use especially how it works or doesnt with large font phone settings.',
                      author: 'Eredrik Johanson',
                      company: 'Financial .INC',
                      image: 'assets/img/comment-1.png'
                    }
                  ].map((testimonial, index) => (
                    <div key={index} className="swiper-slide">
                      <div className="testi-item">
                        <div className="quote-icon"><i className="las la-quote-right"></i></div>
                        <p>{testimonial.quote}</p>
                        <div className="testi-author">
                          <div className="author-thumb">
                            <img src={testimonial.image} alt="author" />
                          </div>
                          <div className="author-info">
                            <h3>{testimonial.author} <span>{testimonial.company}</span></h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="swiper-pagination"></div> {/* Carousel Dots */}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="feature-wrap">
              <div className="section-heading mb-30 wow fade-in-right" data-wow-delay="200ms">
                <h4 className="white"><span></span>Why Choose Us!</h4>
                <h2 className="white">Why Ride with Ridek?</h2>
                <p className="white">
                  We successfully cope with tasks of varying complexity, provide long-term guarantees and regularly master technologies.
                </p>
              </div>
              {/*/.section-heading*/}
              <ul className="ridek-features">
                {[
                  { icon: 'las la-gem', title: 'Safe Guarantee', description: 'We successfully cope with tasks of varying complexity!' },
                  { icon: 'las la-taxi', title: 'Fast Pickups', description: 'We successfully cope with tasks of varying complexity!' },
                  { icon: 'las la-tachometer-alt', title: 'Quick Ride', description: 'We successfully cope with tasks of varying complexity!' }
                ].map((feature, index) => (
                  <li key={index} className="wow fade-in-right" data-wow-delay={`${(index + 3) * 100}ms`}>
                    <div className="feature-icon">
                      <i className={feature.icon}></i>
                    </div>
                    <div className="feature-content">
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="cta-section padding">
      <div className="cta-men wow fade-in-bottom" data-wow-delay="200ms"></div>
      <div className="container">
        <div className="cta-content">
          <h2>
            Call Us Now <span>Book Your Taxi</span> <br /> For Your Next Ride!
          </h2>
          <p>
            We successfully cope with tasks of varying complexity, <br />
            guarantees and regularly master new technologies.
          </p>
          <div className="cta-call">
            <i className="las la-phone-volume"></i>
            <p>
              <span>Call For Taxi</span>
              <a href="tel:+9779852020093">+977-9852020093</a>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section className="blog-section bg-grey padding">
      <div className="container">
        <div className="section-heading text-center mb-40 wow fade-in-bottom" data-wow-delay="200ms">
          <h4>
            <span></span>Recent Posts!
          </h4>
          <h2>News And Insights!</h2>
          <p>
            We successfully cope with tasks of varying complexity, provide long-term <br /> guarantees and
            regularly master new technologies.
          </p>
        </div>
        {/*/.section-heading*/}
        <div className="row grid-post">
          <div className="col-lg-4 col-md-6 padding-15">
            <div className="post-card">
              <div className="post-thumb">
                <img src="/assets/img/post-1.jpg" alt="post" />
                <a href="blog-details.html" className="post-category">Business</a>
              </div>
              <div className="post-content-wrap">
                <ul className="post-meta">
                  <li>
                    <i className="las la-calendar"></i>Jan 01 2022
                  </li>
                  <li>
                    <i className="las la-user"></i>Elliot Alderson
                  </li>
                </ul>
                <div className="post-content">
                  <h3>
                    <a href="blog-details.html" className="hover">
                      How to start initiating a startup in few days.
                    </a>
                  </h3>
                  <p>
                    Financial experts support or help you to find out which way you can raise your funds more...
                  </p>
                  <a href="blog-details.html" className="read-more">
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 padding-15">
            <div className="post-card">
              <div className="post-thumb">
                <img src="/assets/img/post-2.jpg" alt="post" />
                <a href="blog-details.html" className="post-category">Startup</a>
              </div>
              <div className="post-content-wrap">
                <ul className="post-meta">
                  <li>
                    <i className="las la-calendar"></i>Jan 01 2022
                  </li>
                  <li>
                    <i className="las la-user"></i>Elliot Alderson
                  </li>
                </ul>
                <div className="post-content">
                  <h3>
                    <a href="blog-details.html">
                      Financial experts support help you to find out.
                    </a>
                  </h3>
                  <p>
                    Financial experts support or help you to find out which way you can raise your funds more...
                  </p>
                  <a href="blog-details.html" className="read-more">
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 padding-15">
            <div className="post-card">
              <div className="post-thumb">
                <img src="/assets/img/post-3.jpg" alt="post" />
                <a href="blog-details.html" className="post-category">Finance</a>
              </div>
              <div className="post-content-wrap">
                <ul className="post-meta">
                  <li>
                    <i className="las la-calendar"></i>Jan 01 2022
                  </li>
                  <li>
                    <i className="las la-user"></i>Elliot Alderson
                  </li>
                </ul>
                <div className="post-content">
                  <h3>
                    <a href="blog-details.html">
                      Innovative business all over the world.
                    </a>
                  </h3>
                  <p>
                    Financial experts support or help you to find out which way you can raise your funds more...
                  </p>
                  <a href="blog-details.html" className="read-more">
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer className="footer-section">
      <div className="footer-top-wrap bg-grey">
        <div className="container">
          <div className="footer-top">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="brand">
                  <a className="footer-logo" href="index.html">
                    <img src="/assets/img/logo4.png" alt="logo" width="80px"/>
                    <p style={{color:"#04542E",fontWeight:"bold",marginBottom:"0px",paddingLeft:"0px",fontSize:"20px"}}>GoSafari</p>
                  </a>
                  <p>
                    We successfully cope with tasks of varying complexity, provide long-term guarantees and
                    regularly master new technologies.
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer-call">
                  <i className="las la-phone-volume"></i>
                  <p>
                    <span>Call For Taxi</span>
                    <a href="tel:+9779852020093">+977-9852020093</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*/.footer-top-wrap*/}
      <div className="footer-mid-wrap">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 sm-padding">
              <div className="footer-item">
                <div className="widget-title">
                  <h3>Working Hours</h3>
                </div>
                <ul className="footer-contact">
                  <li><span>Monday - Sunday:</span>24X7 hrs support</li>
                  {/* <li><span>Saturday:</span> 10.00am To 7.30pm</li>
                  <li><span>Sunday:</span> Closed</li> */}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 sm-padding">
              <div className="footer-item footer-list">
                <div className="widget-title">
                  <h3>Useful Links</h3>
                </div>
                <ul className="footer-links">
                  <li><a href="book-taxi.html">Taxi Booking</a></li>
                  <li><a href="faqs.html">Help Center</a></li>
                  <li><Link to="/privacy-policy">Privacy and Policy</Link></li>
                  <li><Link to="/terms-and-conditions">Terms of Use</Link></li>
                  {/* <li><a href="contact.html">Contact Us</a></li> */}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 sm-padding">
              <div className="footer-item">
                <div className="widget-title">
                  <h3>Head Office</h3>
                </div>
                <ul className="footer-contact">
                  <li><span>Location:</span>Biratnagar, Nepal</li>
                  <li><span>Join Us:</span>info@gosafarinepal.com</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 sm-padding">
              <div className="footer-item subscribe-wrap">
                <div className="widget-title">
                  <h3>Newsletter Signup</h3>
                </div>
                <form action="#" className="subscribe-form">
                  <input className="form-control" type="email" name="email" placeholder="Your Email" required />
                  <input type="hidden" name="action" value="mailchimpsubscribe" />
                  <button className="submit">Subscribe Now</button>
                  <div className="clearfix"></div>
                  <div id="subscribe-result">
                    <div className="subscription-success"></div>
                    <div className="subscription-error"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="running-taxi">
          <div className="taxi"></div>
          <div className="taxi-2"></div>
          <div className="taxi-3"></div>
        </div>
      </div>                                                          
      {/*/.footer-mid-wrap*/}
      <div className="copyright-wrap">
        <div className="container">
          <p>© <span id="currentYear">{new Date().getFullYear()}</span> GoSafari All Rights Reserved.</p>
        </div>
      </div>
      {/*/.copyright-wrap*/}
    </footer>

    </div>
  );
}

export default Home;
